import NavResponsiveModal, {
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/components/Navigation/NavResponsiveModal';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';
import { Grid, MenuItem, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { css } from '@emotion/react';

// Partially receive an item: pick how many of its quantity arrived. The received portion is split
// off and marked received; the remainder stays on the manifest as Not Received. Reuses the same
// quantity-split mechanic as the create-manifest dialog (see store.confirmPartialReceive).
const PartialReceive = ({ target, loading, callbacks }) => {
    const item = target?.item;
    const qty = item?.quantity || 1;
    const [received, setReceived] = useState(qty > 1 ? qty - 1 : 1);

    useEffect(() => {
        setReceived(qty > 1 ? qty - 1 : 1);
    }, [qty, item?.item_id]);

    const onClose = () => callbacks.openPartialReceive(null);

    return (
        <NavResponsiveModal open={!!item} onClose={onClose}>
            <ModalHeader title="Partially Receive Item" />
            <ModalContent
                css={css`
                    width: 440px;
                `}
            >
                <Grid
                    container
                    direction="column"
                    css={css`
                        flex-wrap: nowrap;
                        gap: 0.75rem;
                    `}
                >
                    <span>
                        Receiving <b>{item?.sku || item?.description || 'this item'}</b> — choose how many of the {qty}{' '}
                        arrived. The remainder stays on the manifest as Not Received.
                    </span>
                    <TextField
                        select
                        variant="outlined"
                        label="Received quantity"
                        value={received}
                        onChange={(e) => setReceived(Number(e.target.value))}
                        InputLabelProps={{ shrink: true }}
                        style={{ maxWidth: 180 }}
                    >
                        {Array.from({ length: qty }, (_, i) => i + 1).map((n) => (
                            <MenuItem key={n} value={n}>
                                {n} of {qty}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </ModalContent>
            <ModalActions>
                <SecondaryButton disabled={loading?.palletLoading} onClick={onClose}>
                    Cancel
                </SecondaryButton>
                <PrimaryButton disabled={loading?.palletLoading} onClick={() => callbacks.confirmPartialReceive(received)}>
                    Receive {received}
                </PrimaryButton>
            </ModalActions>
        </NavResponsiveModal>
    );
};

export default PartialReceive;
